import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBankNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 3c-2.163 0-4.038.542-5.67 1.044l-.304.094C9.486 4.614 8.235 5 7 5a12.44 12.44 0 0 1-2.343-.222l-.032-.006c-.488-.094-.898-.173-1.217-.215-.279-.037-.693-.08-1.072.053-.198.07-.413.169-.616.337-.203.167-.341.36-.447.541-.195.334-.236.712-.254.983C1 6.761 1 7.13 1 7.555v10.796c0 .197 0 .43.119.76.06.164.156.322.213.409.056.086.161.239.287.36.082.077.175.159.286.232.109.072.208.115.251.134l.008.004c.82.361 2.29.75 4.836.75 2.163 0 4.038-.543 5.67-1.044l.304-.094C14.514 19.386 15.765 19 17 19c.886 0 1.677.094 2.343.222l.032.006c.488.094.898.173 1.216.215.28.037.694.08 1.073-.053.198-.07.413-.169.616-.337.203-.167.341-.36.447-.541.195-.334.236-.712.254-.983.019-.29.019-.659.019-1.084V5.649c0-.197 0-.43-.119-.76a2.108 2.108 0 0 0-.213-.409 2.1 2.1 0 0 0-.287-.36 2.01 2.01 0 0 0-.286-.232c-.109-.072-.208-.115-.251-.134l-.008-.003C21.016 3.389 19.546 3 17 3Zm2 6a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9ZM8.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM6 10a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgBankNote01.displayName = 'BankNote01';
export default SvgBankNote01;
